import { ProductQty, SelectedItemMap } from '@common/models';

import { isActualProduct } from './isActualProduct';

// this creates a minimal PricedProduct from a list of selected products, only valid products allowed
export const productQtyFromSelectedItems = (selectedItems: SelectedItemMap): ProductQty[] =>
    [...selectedItems.entries()]
        .filter(
            ([productId, selectedItem]) =>
                selectedItem.isSelected && selectedItem.quantity > 0 && isActualProduct(productId)
        )
        .map(([productId, selectedItem]) => ({ productId, quantity: selectedItem.quantity }));
